import { LocationEntityLink } from '@mark43/cad-api';
import { GenericObject } from '../common/types';
import { EventPanelVehicleBaseKey } from '../event-panel/event-panel-form/involved-person-vehicle-fields/types';
import { EntityPanelFormPersonBaseKey } from '../panels/entity-panels/forms/types';

export const PREFILLED_WITH_UNIT_GPS_LOCATION_MESSAGE = 'Prefilled with unit GPS location';

export const vehiclesBaseKeys: readonly EventPanelVehicleBaseKey[] = [
    'vehicles',
    'towVehicles',
    'mergedVehicles',
    'mergedTowVehicles',
];

export const personsBaseKeys: readonly EntityPanelFormPersonBaseKey[] = [
    'involvedPersons',
    'reportingParties',
    'mergedInvolvedPersons',
    'mergedReportingParties',
];

export const buttonBreakpoints = {
    ADD_TOW_VEHICLE: 875,
    ADD_REPORTING_PARTY: 750,
    ADD_INVOLVED_PERSON: 500,
    ADD_VEHICLE: 300,
};

export const mappedSubdivisionAttrIdsLabels: GenericObject<keyof LocationEntityLink> = {
    // Police
    policeSubdivision1: 'subdivision1AttrId',
    policeSubdivision2: 'subdivision2AttrId',
    policeSubdivision3: 'subdivision3AttrId',
    policeSubdivision4: 'subdivision4AttrId',
    policeSubdivision5: 'subdivision5AttrId',

    // Fire
    fireSubdivision1: 'subdivisionFire1AttrId',
    fireSubdivision2: 'subdivisionFire2AttrId',
    fireSubdivision3: 'subdivisionFire3AttrId',
    fireSubdivision4: 'subdivisionFire4AttrId',
    fireSubdivision5: 'subdivisionFire5AttrId',

    // EMS
    emsSubdivision1: 'subdivisionMedical1AttrId',
    emsSubdivision2: 'subdivisionMedical2AttrId',
    emsSubdivision3: 'subdivisionMedical3AttrId',
    emsSubdivision4: 'subdivisionMedical4AttrId',
    emsSubdivision5: 'subdivisionMedical5AttrId',
};

export const validateAndDirtyFormField = {
    shouldValidate: true,
    shouldDirty: true,
};

export const HIDDEN_SUBDIVISION_FIELDS_NAMES = [
    'policeSubdivision1',
    'policeSubdivision2',
    'policeSubdivision3',
    'policeSubdivision4',
    'policeSubdivision5',
    'fireSubdivision1',
    'fireSubdivision2',
    'fireSubdivision3',
    'fireSubdivision4',
    'fireSubdivision5',
    'emsSubdivision1',
    'emsSubdivision2',
    'emsSubdivision3',
    'emsSubdivision4',
    'emsSubdivision5',
] as const;
